/**
 * Tailwind CSS implementation of Banner component
 * Uses Seeds banner CSS classes from banner.css
 */

import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import Button from "@sproutsocial/seeds-react-button";
import Icon from "@sproutsocial/seeds-react-icon";
import { getBannerIconName, getBannerIconColor } from "./bannerIcon";
import type { TypeBannerProps } from "./BannerTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

/** TODO: change to 'info' type by default in future version */
const BannerTailwind = ({
  type = "info",
  variant = "default",
  text,
  onClose,
  closeButtonLabel = "Close",
  typeIconProps,
  className,
  ...rest
}: TypeBannerProps) => {
  const variantClass =
    variant === "ghost" ? "seeds-banner-ghost" : `seeds-banner-${type}`;

  return (
    <div
      className={cn("seeds-banner", variantClass, className)}
      data-qa-alert=""
      data-qa-alert-type={type}
      data-qa-alert-text={text}
      {...(rest as React.HTMLAttributes<HTMLDivElement>)}
    >
      <Box display="flex" alignItems="center" width={1}>
        <Icon
          name={getBannerIconName(type)}
          color={getBannerIconColor(type, variant)}
          className="Icon seeds-banner-icon"
          fixedWidth
          mt={100}
          mr={350}
          {...typeIconProps}
        />
        {text}
        {onClose && (
          <Box ml="auto" pl={400} alignSelf="flex-start">
            <Button p={0} onClick={onClose} ariaLabel={closeButtonLabel}>
              <Icon name="x-outline" aria-hidden />
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default BannerTailwind;
